// Phase 33 — CMS API service
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const cmsApi = axios.create({ baseURL: BASE_URL, timeout: 15000 });

cmsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('dwi_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

cmsApi.interceptors.response.use(
  (r) => r.data,
  (e) => Promise.reject(e.response?.data || { message: 'Request failed' })
);

// ── Public (no auth) ─────────────────────────────────────────
export const cmsPublic = {
  getCompany:           ()     => cmsApi.get('/cms/public/company'),
  getCountries:         ()     => cmsApi.get('/cms/public/countries'),
  getCountry:           (code) => cmsApi.get(`/cms/public/country/${code}`),
  getPage:              (slug) => cmsApi.get(`/cms/public/page/${slug}`),
  getPages:             (cat)  => cmsApi.get('/cms/public/pages', { params: { category: cat } }),
  getBanners:           (type) => cmsApi.get('/cms/public/banners', { params: type ? { type } : {} }),
  getSocial:            ()     => cmsApi.get('/cms/public/social'),
  getVersion:           ()     => cmsApi.get('/cms/public/version'),
};

// ── Admin (JWT required) ──────────────────────────────────────
export const cmsAdmin = {
  // Company
  getCompany:           ()       => cmsApi.get('/cms/admin/company'),
  updateCompany:        (data)   => cmsApi.put('/cms/admin/company', data),
  publishCompany:       ()       => cmsApi.post('/cms/admin/company/publish'),
  rollbackCompany:      ()       => cmsApi.post('/cms/admin/company/rollback'),

  // Country profiles
  getCountries:         ()       => cmsApi.get('/cms/admin/countries'),
  getCountry:           (code)   => cmsApi.get(`/cms/admin/countries/${code}`),
  saveCountry:          (data)   => cmsApi.post('/cms/admin/countries', data),
  updateCountry:        (code, data) => cmsApi.put(`/cms/admin/countries/${code}`, data),
  publishCountry:       (code)   => cmsApi.post(`/cms/admin/countries/${code}/publish`),
  deleteCountry:        (code)   => cmsApi.delete(`/cms/admin/countries/${code}`),

  // Pages
  getPages:             (cat)    => cmsApi.get('/cms/admin/pages', { params: cat ? { category: cat } : {} }),
  getPage:              (slug)   => cmsApi.get(`/cms/admin/pages/${slug}`),
  savePage:             (data)   => cmsApi.post('/cms/admin/pages', data),
  publishPage:          (slug)   => cmsApi.post(`/cms/admin/pages/${slug}/publish`),
  rollbackPage:         (slug)   => cmsApi.post(`/cms/admin/pages/${slug}/rollback`),
  deletePage:           (slug)   => cmsApi.delete(`/cms/admin/pages/${slug}`),

  // Banners
  getBanners:           (type)   => cmsApi.get('/cms/admin/banners', { params: type ? { type } : {} }),
  createBanner:         (data)   => cmsApi.post('/cms/admin/banners', data),
  updateBanner:         (id, data) => cmsApi.put(`/cms/admin/banners/${id}`, data),
  deleteBanner:         (id)     => cmsApi.delete(`/cms/admin/banners/${id}`),

  // Social
  getSocial:            ()       => cmsApi.get('/cms/admin/social'),
  updateSocial:         (data)   => cmsApi.put('/cms/admin/social', data),
  publishSocial:        ()       => cmsApi.post('/cms/admin/social/publish'),

  // Version
  getVersion:           ()       => cmsApi.get('/cms/admin/version'),
  updateVersion:        (data)   => cmsApi.put('/cms/admin/version', data),
  publishVersion:       ()       => cmsApi.post('/cms/admin/version/publish'),

  // Audit log
  getAudit:             (params) => cmsApi.get('/cms/admin/audit', { params }),
};
